var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwitchGray = function SvgSwitchGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.7778 0H5C2.24306 0 0 2.24306 0 5C0 7.75694 2.24306 10 5 10H12.7778C15.5347 10 17.7778 7.75694 17.7778 5C17.7778 2.24306 15.5347 0 12.7778 0ZM12.7778 8.88889C12.0086 8.88889 11.2568 8.66081 10.6172 8.23349C9.9777 7.80618 9.47925 7.19881 9.18491 6.48821C8.89057 5.77761 8.81356 4.99569 8.96361 4.24132C9.11367 3.48695 9.48405 2.79401 10.0279 2.25014C10.5718 1.70627 11.2647 1.33589 12.0191 1.18584C12.7735 1.03578 13.5554 1.11279 14.266 1.40714C14.9766 1.70148 15.584 2.19992 16.0113 2.83945C16.4386 3.47897 16.6667 4.23085 16.6667 5C16.6656 6.03106 16.2555 7.01957 15.5264 7.74864C14.7973 8.47771 13.8088 8.88779 12.7778 8.88889Z",
    fill: "black"
  })));
};
export default SvgSwitchGray;